import { z } from "zod";
/**
 * Início de uma instância de workflow de aprovação (FASE-06-T48).
 * `type` referencia uma `WorkflowDefinition` já registrada
 * (GET /v1/workflows/definitions); `payload` é interpretado pela definição —
 * o motor nunca lê campos específicos de um tipo.
 */
export const startWorkflowSchema = z.object({
    type: z.string().trim().min(1).max(60),
    /** Colaborador alvo da solicitação; default = self do requerente. */
    employeeId: z.string().uuid().optional(),
    payload: z.record(z.string(), z.unknown()).optional(),
});
//# sourceMappingURL=start-workflow.js.map